import React, {
  createRef,
  ReactElement,
  useEffect,
  useRef,
  useState,
} from 'react';
import {BackButtonAction} from '../../../core/utils/string.util';
import useGeoLocation from '../../../components/common/useGeoLocation';

import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {useHistory} from 'react-router-dom';
import Stepper from '../../../components/stepper/Stepper';
import rightCursorArrow from '../../../assets/images/right_cursor_arrow.svg';
import ProductCard from './ProductCard';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import CustomModal from '../../../components/modal/CustomModal';
import CouponForm from './CouponForm';
import Freebies from './Freebies';
import AddBag from './AddBag';
import CartInfo from '../CartInfo';
import RupeesIcon from '../../../assets/images/rupees.svg';
import CongratsIcon from '../../../assets/images/congratulation.svg';
import CartEmptyIcon from '../../../assets/images/cart_empty.svg';
import SuccessToast from '../../../components/notifications/SuccessToast';
import {
  setShowGobackModal,
  showGobackModal,
} from '../../../redux/checkoutSlice';
import {beginCheckoutEventGA,
  removeFromCartEventGA,
setPageName} from '../../../lib/tagmanager';
import {
  getAccessToken,
  getAllOffers,
  getStoreInformation,
  setAllOffers,
  getUser,
  getStoreCode,
  getUserType,
  setUserType,
  setStoreCode,
  setStoreInformation,
  getMetadata,
  getStoreEmployeeInfo,
  setpaymentConfirm,
} from '../../../core/localstorage-data';
import {getWithExpiry} from '../../../core/localstorage-utils';
import {offers} from '../../../redux/offerSlice';
import cogoToast from 'cogo-toast';
import {
  orderResponse,
  fetchOrder,
  deleteItem,
  resetOrderState,
  setCouponApplied,
  couponApplied,
  notification,
  resetNotification,
  addBag,
  removeBag,
  mmrpError,
  fetchFreebies,
  removeCoupon,
  removeFreebie,
  setCartItemsCount,
  fetchPromos,
  orderAddBagResponse,
  orderAddBagLoading,
  orderAddBagError,
  resetAddBagResponse,
  orderRemoveBagLoading,
  orderRemoveBagResponse,
  orderRemoveBagError,
  resetRemoveBagResponse,
} from '../../../redux/orderSlice';
import {ItemListType, OrderResponse} from '../../../lib/order-types';
import {logout} from '../../../core/utils/routing.util';
import Thankyou from '../confirm/Thankyou';
import ErrorToast from '../../../components/notifications/ErrorToast';
import {pageName} from '../../../lib/constants';
import {
  pushtoPoshOrder,
  PosApiResponseData,
  resetPosState,
  errorInPosApi,
  PosApiLoading,
} from '../../../redux/posSlice';
import {distancePoints} from '../../../lib/commonFunction';
import {
  coupanAppliedMoengage,
  proceedToCheckoutMoengageCall,
} from '../../../lib/moengageCall';
import {CHECKOUT_PATH, HOME_ROUTE_PATH} from '../../../routes/route-constants';

type PriceDetails = {
  totalMRP: number;
  promoDiscountAmount: number;
  totalAmount: number;
  bagPrice: number;
  couponDiscount: number;
  // freeBiePrice: number;
};
declare const window: any;
const ShoppingBag: React.FC = (): ReactElement => {
  let BAG_PRICE = 0;
  const storeCode = `0${getStoreInformation().store_code}`;
  const card_number = getUser().cardNumber;
  const storeId = getStoreCode();

  const accessToken = getAccessToken();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [hasPromoApplied, setHasPromoApplied] = useState(false);
  const [showRemoveFreebieModal, setShowRemoveFreebieModal] = useState(false);
  const [proceedToCheckoutClicked, setProceedToCheckoutClicked] =
    useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [showBagModal, setShowBagModal] = useState(false);
  const [showFreebiesModal, setShowFreebiesModal] = useState(false);
  const [priceDetails, setPriceDetails] = useState<PriceDetails | null>(null);
  const [tg, setTg] = useState<any>(null);
  // const ORDER_ID = getOrderID();
  const unblockHandle = useRef<any>();
  //TODO:
  //need to get from the localstorage
  const userType = getUserType();
  let location: any;
  if (userType == 'employee') {
    location = useGeoLocation();
  }
  //TODO: uncomment
  // const storeInformation = getStoreInformation();
  // const storeId = storeInformation?.store_code;
  const getCoupons = () => {
    const allOffersFromLS = getAllOffers();
    if (allOffersFromLS && allOffersFromLS.length > 0) {
      return allOffersFromLS;
    } else return [];
  };
  const orderResp = useAppSelector(orderResponse);
  const notificationState = useAppSelector(notification);

  const orderRemoveBagResp = useAppSelector(orderRemoveBagResponse);
  const removeBagLoading = useAppSelector(orderRemoveBagLoading);
  const removeBagError = useAppSelector(orderRemoveBagError);

  const orderAddBagResp = useAppSelector(orderAddBagResponse);
  const addBagLoading = useAppSelector(orderAddBagLoading);
  const addBagError = useAppSelector(orderAddBagError);
  const apiError = useAppSelector(mmrpError);
  const employDetail = getStoreEmployeeInfo();
  const [coupons, setCoupons] = useState(getCoupons());
  const [hasFreebiesCalled, setHasFreebiesCalled] = useState(false);
  const [deleteFreebiesModal, setDeleteFreebiesModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<ItemListType | null>(null);
  const [employeeClickCheckoutButton, setEmployeeClickCheckoutButton] =
    useState(true);
  const [Thankyouscreen, setThankyouScreen] = useState(false);
  const dispatch = useAppDispatch();
  const showGobackModalValue = useAppSelector(showGobackModal);
  const isCouponApplied = useAppSelector(couponApplied);
  const myOffers = useAppSelector(offers);
  const scrollerRef = createRef();
  const navigate = useHistory();
  const metaData = getMetadata();

  const posData = useAppSelector(PosApiResponseData);
  const PosApiHasError = useAppSelector(errorInPosApi);
  const PosApiHasLoaded = useAppSelector(PosApiLoading);
  const bagMetaData = metaData.find(
    (obj: {name: string}) => obj.name === 'bag-price',
  );
  if (bagMetaData) {
    BAG_PRICE = bagMetaData.value;
  }

  if (userType === null) {
    logout();
  }
  useEffect(() => {
    setPageName(pageName.shoppingPage);
    if (employeeClickCheckoutButton === false) {
      setEmployeeClickCheckoutButton(true);
    }
  }, []);

  useEffect(() => {
    if (
      orderResp &&
      orderResp.itemList &&
      orderResp.itemList.length &&
      hasPromoApplied === false
    ) {
      setHasPromoApplied(true);
      const parameters = {
        accessToken: accessToken,
        payload: {
          storeCode: storeCode,
          cardNumber: card_number,
          orderId: orderResp.orderId,
        },
      };
      dispatch(fetchPromos(parameters));
    }
  }, [orderResp]);

  useEffect(() => {
    /**
     * block route change when form is dirty
     * except when going next
     */
    unblockHandle.current = navigate.block((targetLocation: any) => {
      setTg(targetLocation);

      let isFreebieApplied = false;
      const freebieAppliedIndex =
        orderResp &&
        orderResp.availableFreeBieList &&
        orderResp.itemList?.findIndex(item => item.isFreebie === true);
      if (freebieAppliedIndex && freebieAppliedIndex >= 0) {
        isFreebieApplied = true;
      } else {
        isFreebieApplied = false;
      }

      if (
        orderResp &&
        (orderResp.appliedCoupon || isFreebieApplied) &&
        targetLocation.pathname !== '/checkout/payment' &&
        targetLocation.pathname !== '/checkout/shoppingbag'
      ) {
        dispatch(setShowGobackModal(true));
        return false;
      }
    });

    /**
     * unblock history when unmounting
     */
    return function () {
      unblockHistory();
    };
  });

  function unblockHistory() {
    if (unblockHandle && unblockHandle.current) {
      unblockHandle.current();
    }
  }

  useEffect(() => {
    const parameters = {
      accessToken: accessToken,
      payload: {
        storeCode: storeCode,
        cardNumber: card_number,
        storeKeyId: storeId,
      },
    };
    dispatch(fetchOrder(parameters));
  }, []);

  useEffect(() => {
    if (
      orderResp &&
      hasFreebiesCalled === true &&
      orderResp.availableFreeBieList &&
      proceedToCheckoutClicked
    ) {
      if (orderResp.availableFreeBieList.length === 0) {
        setShowBagModal(true);
      }
      setProceedToCheckoutClicked(false);
    }
  }, [orderResp, notificationState]);

  useEffect(() => {
    if (apiError !== '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong, Please try again."
        />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [apiError]);

  useEffect(() => {
    if (notificationState && notificationState.statusCode === '202') {
      removeFromCartEventGA(itemToDelete);
      cogoToast.success(
        <SuccessToast
          title="Item has been deleted"
          description={`${itemToDelete?.itemDesc} has been deleted from your bag`}
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
      dispatch(resetNotification());
    }

    if (
      isCouponApplied === true &&
      notificationState &&
      notificationState.statusCode === '201'
    ) {
      cogoToast.success(
        <SuccessToast
          title="Coupon applied"
          description="The coupon has been applied to your bag total"
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
      dispatch(resetNotification());
    }

    if (
      isCouponApplied &&
      notificationState &&
      notificationState.statusCode === '203'
    ) {
      dispatch(setCouponApplied(false));
      dispatch(setShowGobackModal(false));
      navigate.goBack();
      dispatch(resetNotification());
    }

    if (notificationState && notificationState.statusCode === '206') {
      setShowFreebiesModal(false);
      dispatch(resetNotification());
      if (orderResp && orderResp.itemList) {
        dispatch(setCartItemsCount(orderResp.itemList.length));
      }
    }
  }, [notificationState, isCouponApplied]);

  useEffect(() => {
    const couponPointsDataFromLocalStorage = getWithExpiry(
      'coupon_point_details',
    );
    let allOffers: any[];
    if (couponPointsDataFromLocalStorage !== null) {
      allOffers = [...couponPointsDataFromLocalStorage];
      allOffers.sort((a, b) => (a.validity > b.validity ? 1 : -1));
      const updatedOffers = allOffers.map(offer => {
        if (offer.description.includes('_.')) {
          const description = offer.description.split('_.')[1].trim();
          return {...offer, description};
        }
        return offer;
      });
      setAllOffers(updatedOffers);
      setCoupons(updatedOffers);
    }
  }, [myOffers]);

  useEffect(() => {
    dispatch(setAppBarTitle('Shopping bag'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.TO_CHECKOUT_HOME));

    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(setBackNavAction(undefined));
      dispatch(setShowGobackModal(false));
    };
  }, [orderResp]);
  useEffect(() => {
    if (posData.message != '' && PosApiHasLoaded === false) {
      if (posData.statusCode === '200') {
        window.Moengage.destroy_session();
        // navigate.push(CHECKOUT_PATH);
        //     navigate.push(CHECKOUT_PATH);
        dispatch(resetPosState());
        const userType = getUserType();
        localStorage.clear();
        if (userType != null) {
          setUserType(userType);
          setpaymentConfirm();
          window.location.href = '/thankyou';
        }
      } else {
        cogoToast.error(
          <ErrorToast
            title="Error"
            description="Something went wrong, Please try again."
          />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
      }

      dispatch(resetPosState());
    }
    if (PosApiHasError != '' && PosApiHasLoaded === false) {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong, Please try again."
        />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );
      dispatch(resetPosState());
    }
  }, [PosApiHasError, posData, PosApiHasLoaded]);
  useEffect(() => {
    if (orderResp !== null) {
      let totalMRP = 0;
      let promoDiscountAmount = 0;
      let bagPrice = 0;
      let couponDiscount = 0;
      orderResp &&
        orderResp.itemList &&
        orderResp.itemList.forEach(item => {
          totalMRP += item.sellPrice;
          promoDiscountAmount += item.promoDiscountAmount;
        });
      if (orderResp && orderResp.carryBagItem) {
        bagPrice = BAG_PRICE * orderResp.carryBagItem.quantity;
      }
      orderResp.itemList &&
        orderResp.itemList.forEach(item => {
          if (item.couponDiscountAmount) {
            couponDiscount += item.couponDiscountAmount;
          } else couponDiscount = 0;
        });
      // let freeBiePrice = 0;
      // if (orderResp && orderResp.selectedFreeBie) {
      //   freeBiePrice += orderResp.selectedFreeBie.extSellPrice;
      // }

      let totalAmount =
        orderResp && orderResp.itemList
          ? orderResp.itemList.reduce((prevAmount, item) => {
              return prevAmount + item.extSellPrice;
            }, 0)
          : 0;
      totalAmount = totalAmount + bagPrice;

      setPriceDetails({
        totalMRP,
        promoDiscountAmount,
        totalAmount,
        bagPrice,
        couponDiscount,
        // freeBiePrice,
      });
    }

    if (
      orderResp !== null &&
      orderResp.statusCode === '206' &&
      orderResp.statusMessage === 'Freebies generated successfully' &&
      orderResp.availableFreeBieList &&
      orderResp.availableFreeBieList.length > 0
    ) {
      setShowFreebiesModal(true);
      if (orderResp && orderResp.itemList) {
        dispatch(setCartItemsCount(orderResp.itemList.length));
      }
    }
  }, [orderResp]);

  function handleDelete(item: ItemListType) {
    setItemToDelete(item);
    setShowDeleteModal(true);
  }
  function modalCloseHandler() {
    setShowDeleteModal(false);
  }
  function modalConfirmHandler() {
    // call delete product api
    const parameters = {
      accessToken: accessToken,
      payload: {
        storeCode: orderResp?.storeCode,
        orderId: orderResp?.orderId,
        itemId: itemToDelete?.itemID,
        itemIdentifier: itemToDelete?.itemIdentifier,
      },
    };
    dispatch(deleteItem(parameters as any));
    setShowDeleteModal(false);
  }

  function freebiesModalConfirmHandler() {
    if (orderResp !== null) {
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          orderId: orderResp.orderId,
        },
      };
      dispatch(removeFreebie(parameters));
    }
    setShowRemoveFreebieModal(false);
  }
  function backModalCloseHandler() {
    dispatch(setShowGobackModal(false));
  }
  function backModalConfirmHandler() {
    localStorage.removeItem('applied_coupon');
    if (orderResp) {
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          orderId: orderResp.orderId,
        },
      };
      dispatch(removeCoupon(parameters));
      if (orderResp && orderResp.selectedFreeBie) {
        dispatch(removeFreebie(parameters));
      }
    }
    unblockHistory();
    dispatch(resetOrderState());
    navigate.push(tg.pathname);
  }

  const _onViewDetailsClicked = () => {
    if (scrollerRef.current) {
      const _el = scrollerRef.current as HTMLDivElement;
      _el.parentElement?.parentElement.scrollTo({top: _el.scrollHeight});
    }
  };

  function handleOpenCouponModal() {
    setShowCouponModal(true);
  }

  function handleProceedToCheckout() {
    setProceedToCheckoutClicked(true);
    if (orderResp != null) {
      proceedToCheckoutMoengageCall(orderResp);
    }
    beginCheckoutEventGA(orderResp);
    // TODO: UnComment later
    // if (
    //   orderResp &&
    //   orderResp.availableFreeBieList &&
    //   orderResp.availableFreeBieList.length > 0
    // ) {
    //   console.log(orderResp);
    //   setShowBagModal(true);
    // } else {
    //   if (orderResp) {
    //     console.log(orderResp);

    //     const parameters = {
    //       accessToken,
    //       payload: {
    //         storeCode,
    //         orderId: orderResp.orderId,
    //       },
    //     };
    //     setHasFreebiesCalled(true);
    //     dispatch(fetchFreebies(parameters));
    //   }
    // }
    // TODO: Comment later
    setShowBagModal(true);
  }

  function handleApplyCoupon() {
    // dispatch(setCouponApplied(true));
    setShowCouponModal(false);
    if (orderResp !== null && orderResp.statusCode === '201') {
      coupanAppliedMoengage(orderResp);
      dispatch(setCouponApplied(true));
    }
  }

  useEffect(() => {
    if (orderRemoveBagResp != null) {
      navigate.push('/checkout/payment');
      dispatch(resetAddBagResponse());
      dispatch(resetOrderState());
    }
    if (removeBagLoading === false && removeBagError != '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong, Please try again."
        />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );

      navigate.push('/checkout/payment');
      dispatch(resetAddBagResponse());
      dispatch(resetOrderState());
    }
  }, [orderRemoveBagResp, removeBagLoading, removeBagError]);

  function handleProceedWithoutBag() {
    if (orderResp) {
      const parameters = {
        accessToken,
        payload: {
          orderId: orderResp.orderId,
          storeCode: orderResp.storeCode,
          quantity: 0,
        },
      };
      dispatch(removeBag(parameters));
    }

    setShowBagModal(false);
  }

  useEffect(() => {
    if (orderAddBagResp != null) {
      navigate.push('/checkout/payment');
      dispatch(resetAddBagResponse());
      dispatch(resetOrderState());
    }

    if (addBagError != '' && addBagLoading) {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong, Please try again."
        />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );

      navigate.push('/checkout/payment');
      dispatch(resetAddBagResponse());
      dispatch(resetOrderState());
    }
  }, [orderAddBagResp, addBagLoading, addBagError]);

  function handleConfirm(quantity: number) {
    if (orderResp) {
      const parameters = {
        accessToken,
        payload: {
          orderId: orderResp.orderId,
          storeCode: orderResp.storeCode,
          quantity,
        },
      };
      dispatch(addBag(parameters));
    }

    setShowBagModal(false);
  }
  function handlePushTOPos() {
    if (location.error.message != '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Please provide the location access to continue"
        />,
        {
          hideAfter: 4,
          renderIcon: () => {
            return null;
          },
        },
      );
      return;
    }
    // const storeLat = 28.7254557;
    // const storeLong = 77.2060128;
    // const userLat = 28.7234;
    // const userLong = 77.206;
    // // const storeLat = storeInformationData.latitude;
    // // const storeLong = storeInformationData.longitude;
    // // const userLat = location.coordinates.lat;
    // // const userLong = location.coordinates.lng;
    // const distance = distancePoints(
    //   userLat,
    //   userLong,
    //   storeLat,
    //   storeLong,
    //   //getStoreLatitude(),
    //   //getStoreLongitude(),
    // );
    // // const distance1 = 301;
    // if (distance <= 300) {
    //   if (orderResp && accessToken) {
    //     const parameters = {
    //       payload: {
    //         storeCode: storeCode,
    //         orderId: orderResp?.orderId,
    //         userId: employDetail.data.userId,
    //       },

    //       accessToken: accessToken,
    //     };
    //     dispatch(pushtoPoshOrder(parameters));
    //   }
    // } else {
    // cogoToast.error(
    //   <ErrorToast title="Error" description="You are not near the store" />,
    //   {
    //     hideAfter: 4,
    //     renderIcon: () => {
    //       return null;
    //     },
    //   },
    // );
    //   window.location.href = 'employeesignin';
    // }
    if (orderResp && accessToken) {
      const parameters = {
        payload: {
          storeCode: storeCode,
          orderId: orderResp?.orderId,
          userId: employDetail.data.userId,
        },

        accessToken: accessToken,
      };
      dispatch(pushtoPoshOrder(parameters));
    }
  }
  function handleEmployeeCheckout() {
    setEmployeeClickCheckoutButton(false);
  }

  function renderCartPage() {
    if (
      orderResp !== null &&
      orderResp.itemList &&
      orderResp.itemList.length <= 0
    ) {
      return (
        <div className="flex flex-nowrap flex-col m-auto pt-6 px-8">
          <div className="stepper-container-horizontal mb-24">
            <Stepper />
          </div>
          <div className="flex flex-col items-center place-items-center">
            <div>
              <img src={CartEmptyIcon} />
            </div>
            <div className="mt-8 mb-2 font-roboto font-medium text-xl">
              Your shopping bag is empty!
            </div>
            <div className="font-roboto text-center">
              Looks like you haven’t scanned anything to your bag yet
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          {Thankyouscreen ? (
            <div>
              {' '}
              <Thankyou />
            </div>
          ) : (
            <div>
              <div
                ref={scrollerRef as React.RefObject<HTMLDivElement>}
                className="overflow-y-scroll pt-6 px-8 pb-48"
                style={{
                  scrollBehavior: 'smooth',
                }}>
                <div className="flex flex-nowrap flex-col m-auto">
                  <div className="stepper-container-horizontal">
                    <Stepper />
                  </div>

                  <div
                    className={`mt-5 flex items-center font-roboto text-small ${
                      priceDetails && priceDetails.promoDiscountAmount > 0
                        ? 'justify-around'
                        : 'justify-end'
                    }`}>
                    {priceDetails && priceDetails.promoDiscountAmount > 0 && (
                      <div className="flex">
                        <span className="mr-1">You are saving </span>
                        <img src={RupeesIcon} />
                        <span className="ml-1">
                          <strong>
                            {priceDetails.promoDiscountAmount.toFixed(2)}
                          </strong>
                        </span>{' '}
                        <span className="ml-1">on this order</span>
                      </div>
                    )}
                    {orderResp &&
                      orderResp.availableFreeBieList &&
                      orderResp.availableFreeBieList.length > 0 && (
                        <div
                          className={`bg-blue_zero rounded-full h-14 w-14`}
                          onClick={() => setShowFreebiesModal(true)}>
                          <img
                            src={CongratsIcon}
                            style={{marginTop: '7px', marginLeft: '11px'}}
                          />
                        </div>
                      )}
                  </div>
                  <div className="font-bold mt-4 mb-2">
                    {orderResp && orderResp.itemList?.length}{' '}
                    {orderResp &&
                    orderResp.itemList?.length &&
                    orderResp.itemList?.length > 1
                      ? 'items'
                      : 'item'}
                  </div>
                  {orderResp && (
                    <ProductCard
                      type="product"
                      onDelete={handleDelete}
                      orderResp={orderResp}
                    />
                  )}
                  {userType === 'employee' &&
                  employeeClickCheckoutButton === false ? (
                    <div>
                      {orderResp && !orderResp.appliedCoupon && (
                        <div
                          onClick={handleOpenCouponModal}
                          className="shadow-max_one bg-blue_one p-4 flex justify-between my-6 rounded-radius20">
                          <div className="self-center">
                            Select and apply coupons
                          </div>
                          <div className="bg-white rounded-radius20 py-1.5 px-2.5">
                            <img src={rightCursorArrow} />
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      {userType === 'customer' ? (
                        <div>
                          {orderResp && !orderResp.appliedCoupon && (
                            <div
                              onClick={handleOpenCouponModal}
                              className="shadow-max_one bg-blue_one p-4 flex justify-between my-6 rounded-radius20">
                              <div className="self-center">
                                Select and apply coupons
                              </div>
                              <div className="bg-white rounded-radius20 py-1.5 px-2.5">
                                <img src={rightCursorArrow} />
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  )}
                  {orderResp && orderResp.selectedFreeBie && (
                    <div className="px-4 py-4 mb-4 bg-blue_two rounded-2xl">
                      <div className="flex justify-between font-roboto items-center">
                        <div className="text-xxl text-left font-bold w-4/5">
                          {orderResp.selectedFreeBie?.itemDesc}
                        </div>
                        <div className="font-medium text-semibig w-1/5">
                          {'\u20B9'} {orderResp.selectedFreeBie.extSellPrice}
                        </div>
                      </div>
                      <div className="mt-2 mb-4 font-roboto">
                        <div className="text-small text-left w-4/5">
                          {orderResp.selectedFreeBie?.promoList[0].promoDesc}
                        </div>
                      </div>
                      <div className="border-gray-300 border-solid border-0.2"></div>
                      <div
                        className="mt-2 text-center text-small font-bold text-red_zero"
                        onClick={() => {
                          setShowRemoveFreebieModal(true);
                        }}>
                        Remove
                      </div>
                    </div>
                  )}

                  {orderResp && (
                    <ProductCard type="price" orderResp={orderResp} />
                  )}
                  <ConfirmModal
                    title="Delete Product?"
                    message={`Are you sure you want to delete ${itemToDelete?.itemDesc} from your bag? Please note any coupon/freebie that has been applied will be cancelled and you will need to reapply`}
                    onClose={modalCloseHandler}
                    open={showDeleteModal}
                    onCancel={modalCloseHandler}
                    onConfirm={modalConfirmHandler}
                  />
                  <ConfirmModal
                    title="Remove freebie"
                    message={`Are you sure you want to remove the freebie that you have added to your bag?`}
                    onClose={() => {
                      setShowRemoveFreebieModal(false);
                    }}
                    open={showRemoveFreebieModal}
                    onCancel={() => {
                      setShowRemoveFreebieModal(false);
                    }}
                    onConfirm={freebiesModalConfirmHandler}
                  />
                  <ConfirmModal
                    title="Go Back!"
                    message="Are you sure you want to go back? Please note the coupon/freebie that has been applied will be cancelled and you will need to reapply"
                    onClose={backModalCloseHandler}
                    open={showGobackModalValue}
                    onCancel={backModalCloseHandler}
                    onConfirm={backModalConfirmHandler}
                  />
                  <CustomModal
                    isVisible={showCouponModal}
                    classNames="top-20 md:top-72"
                    onClose={() => {
                      setShowCouponModal(false);
                      if (orderResp && orderResp.appliedCoupon) {
                        const parameters = {
                          accessToken,
                          payload: {
                            storeCode,
                            orderId: orderResp.orderId,
                          },
                        };

                        dispatch(removeCoupon(parameters));
                        dispatch(setCouponApplied(false));
                      }
                    }}>
                    <CouponForm
                      coupons={coupons}
                      onApplyCoupon={handleApplyCoupon}
                    />
                  </CustomModal>

                  <CustomModal
                    // classNames="top-2/4"
                    isVisible={showBagModal}
                    onClose={() => {
                      setShowBagModal(false);
                      setHasFreebiesCalled(false);
                    }}>
                    <AddBag
                      onProceedWithoutBag={handleProceedWithoutBag}
                      onConfirm={handleConfirm}
                      orderResp={orderResp}
                    />
                  </CustomModal>
                  {orderResp &&
                    orderResp.availableFreeBieList &&
                    orderResp.availableFreeBieList.length > 0 && (
                      <CustomModal
                        // classNames="top-2/4"
                        classNames="h-contentbig"
                        isVisible={showFreebiesModal}
                        onClose={() => {
                          setShowFreebiesModal(false);
                        }}>
                        <Freebies orderResp={orderResp} />
                      </CustomModal>
                    )}
                </div>
              </div>
              <div>
                {userType === 'employee' &&
                employeeClickCheckoutButton === true ? (
                  <CartInfo
                    className="mb-16"
                    custType={'employee'}
                    onViewDetailsClicked={_onViewDetailsClicked}
                    onEmployeeCheckout={handleEmployeeCheckout}
                    onPushToPos={handlePushTOPos}
                    totalAmount={priceDetails?.totalAmount}
                    showViewDetails={true}
                  />
                ) : (
                  <CartInfo
                    className="mb-16"
                    custType={'customer'}
                    onViewDetailsClicked={_onViewDetailsClicked}
                    onProceed={handleProceedToCheckout}
                    totalAmount={priceDetails?.totalAmount}
                    showViewDetails={true}
                  />
                )}
              </div>
            </div>
          )}
        </>
      );
    }
  }
  return renderCartPage();
};

export default ShoppingBag;
